import { ApiSupportClient } from "../api-support.client";
import { ApiClient } from "../api.client";
import {
  AuthenticateAsSupportRequest,
  AuthenticateAsSupportResponse,
  GetActiveSupportChatsRequest,
  GetActiveSupportChatsResponse,
  GetChatMessagesRequest,
  GetChatMessagesResponse,
  ReadMessageRequest,
  SendMessageRequest,
  SendMessageResponse,
  StartFeedbackChatRequest,
  StartFeedbackChatResponse,
} from "./types";

const ChatsApi = {
  getActiveSupportChats(params: GetActiveSupportChatsRequest) {
    return ApiClient.get<GetActiveSupportChatsResponse>(
      "/admin/chats/support",
      {
        params,
      }
    );
  },
  authenticateAsSupport() {
    return ApiClient.post<
      AuthenticateAsSupportRequest,
      AuthenticateAsSupportResponse
    >("/admin/chats/support/authenticate");
  },
  startFeedbackChat(body: StartFeedbackChatRequest) {
    return ApiClient.post<StartFeedbackChatRequest, StartFeedbackChatResponse>(
      "/admin/chats/support/open",
      body
    );
  },
  getChatMessages({ chatId, ...params }: GetChatMessagesRequest) {
    return ApiSupportClient.get<GetChatMessagesResponse>(
      `/chats/${chatId}/messages`,
      { params }
    );
  },
  sendMessage({ chatId, ...body }: SendMessageRequest) {
    return ApiSupportClient.post<SendMessageRequest, SendMessageResponse>(
      `/chats/${chatId}/messages/text/send`,
      body
    );
  },
  readMessage({ messageId }: ReadMessageRequest) {
    return ApiSupportClient.post<SendMessageRequest, SendMessageResponse>(
      `/chats/messages/${messageId}/read`
    );
  },
};

export { ChatsApi };
